import { makeAnalyticsAction, partialDocumentInformation, documentIdentifier, validateResultPayload, } from '../analytics/analytics-utils.js';
export const logRecentResultClick = (result) => makeAnalyticsAction('analytics/recentResults/click', (client, state) => {
    validateResultPayload(result);
    return client.makeRecentResultClick(partialDocumentInformation(result, state), documentIdentifier(result));
});
export const logClearRecentResults = () => makeAnalyticsAction('analytics/recentResults/clear', (client) => client.makeClearRecentResults());
